import { createSlice } from "@reduxjs/toolkit";
import { API_LOAD_STATUS } from "constants/labels";
import { initialState } from "container/mapCenter/store/initialState";
import {
  getCountyApi,
  getHistoryByIdApi,
  getMapRequestByIdApi,
  getMapRequestDropdownDataFilterApi,
  getRequestTypeApi,
  getSecurityReviewDropdownDataFilterApi,
  getStateApi,
  getStatusApi,
  postMapRequestCreateApi,
  postMapRequestFilterApi,
  postReviewMapRequestApi,
} from "services/mapCenter/mapCenter.thunks";

const name = "mapCenter";
export const mapCenterPortalSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const { PENDING, FULFILLED, REJECTED } = API_LOAD_STATUS;
    const addCaseGroup = (thunk, key) => {
      builder
        .addCase(thunk.pending, (state) => {
          state[key].Load = {
            ...state[key].Load,
            status: PENDING,
          };
          state[key].Succeeded = false;
          state[key].Data = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          const actionPayload = action.payload;
          const Data = actionPayload?.Data;
          const message = actionPayload?.Message;
          const Succeeded = actionPayload?.Succeeded;

          state[key].Load = {
            ...state[key].Load,
            status: FULFILLED,
            message,
          };
          state[key].Succeeded = Succeeded ?? false;
          state[key].Data = Data ?? null;
        })
        .addCase(thunk.rejected, (state, action) => {
          const { Message, Errors } = action.payload;
          state[key].Load = {
            ...state[key].Load,
            status: REJECTED,
            message: Message,
            errors: Errors,
          };
          state[key].Succeeded = false;
          state[key].Data = null;
        });
    };

    /** Define case group here for each state-thunk */
    addCaseGroup(getRequestTypeApi, "requestType");
    addCaseGroup(getCountyApi, "county");
    addCaseGroup(getStateApi, "state");
    addCaseGroup(postMapRequestCreateApi, "mapRequestCreate");
    addCaseGroup(getMapRequestByIdApi, "mapRequestById");
    // addCaseGroup(getMapRequestApi, "mapRequestList");
    addCaseGroup(getHistoryByIdApi, "interactionHistory");
    addCaseGroup(postMapRequestFilterApi, "mapRequestFilter");
    addCaseGroup(postReviewMapRequestApi, "reviewMapRequest");
    addCaseGroup(
      getMapRequestDropdownDataFilterApi,
      "mapRequestDropdownFilter"
    );
    addCaseGroup(
      getSecurityReviewDropdownDataFilterApi,
      "securityReviewDropdownFilter"
    );
    addCaseGroup(getStatusApi, "status");
  },
});

export const { setMapListFilterParams } = mapCenterPortalSlice.actions;
